/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsForSaasDataServices extends models.FilterOptionsForSaasBase {
    getFixupPrototypeFunction() { return FilterOptionsForSaasDataServices.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsForSaasDataServices>): FilterOptionsForSaasDataServices {
        let obj = Object.assign(new FilterOptionsForSaasDataServices(), model);
        FilterOptionsForSaasDataServices.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsForSaasDataServices>): FilterOptionsForSaasDataServices {
        if (!model) return null;
        return FilterOptionsForSaasDataServices.newInstance(<FilterOptionsForSaasDataServices> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsForSaasDataServices) {
        if (!obj) return;

        models.FilterOptionsForSaasDataServices.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsForSaasDataServices): boolean {
        if (models.FilterOptionsForSaasBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FilterOptionsForSaasDataServices.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of SaaS services supported for the role template
     */
    saas: models.SaasDataServiceName;

}
